/**
 * Simple phone number regular expression tester
 * @return {RegExp}
 */
export const phoneNumberTester = () => new RegExp(/^[0-9]{11}$/, 'g')



// WEBPACK FOOTER //
// ./src/libs/useRegExp.js